import { USER_ACCESS } from "@/constants";
import { useInviteContext } from "@/containers/InviteWizard/InviteContext";
import Button from "@components/Button";
import Rhythm from "@components/Rhythm";
import Typography from "@components/Typography";
import { useWizard } from "@components/Wizard";

export type SetReportSubscriptionsProps = { className?: string };

import ArrowLeft from "@/assets/icons/arrow-left.svg";
import ReportSubscriptions from "@/containers/ReportSubscriptions";

import styles from "../InviteWizard.module.css";

const SetReportSubscriptions: React.FunctionComponent<
  SetReportSubscriptionsProps
> = () => {
  const { next, previous } = useWizard();
  const { organizationUuid } = useInviteContext();
  const user = useInviteContext().user!;

  // Once a user has been created, get the report subscriptions for that user ( there might be defaults added )

  return (
    <div>
      <Rhythm>
        <Typography variant="h3" data-testid="user-add-step-3-title">
          {L.ORGANIZATION_INVITE_USER_REPORT_SUBSCRIPTIONS_TITLE}
        </Typography>
        <Typography>
          {user.user_type === USER_ACCESS.USER
            ? L.ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_SUBTITLE_USER
            : L.ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_SUBTITLE_READONLY}
        </Typography>
      </Rhythm>
      <Rhythm>
        <ReportSubscriptions
          className={styles.longtable}
          organizationUuid={organizationUuid}
          userId={user.id}
        />
      </Rhythm>
      <Rhythm className={styles.actions}>
        <Button icon={ArrowLeft} onClick={previous} variant="tertiary">
          {L.ORGANIZATION_INVITE_PREVIOUS_STEP}
        </Button>
        <Button onClick={next} data-testid="user-add-step-3-continue">
          {L.ORGANIZATION_INVITE_NEXT_STEP}
        </Button>
      </Rhythm>
    </div>
  );
};

export default SetReportSubscriptions;
